<template>
  <slot />
</template>

<script lang="ts" setup>

useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover' },
    { name :'thema-color', content: '#ffffff' }
  ]
})
</script> 
<style lang="scss">
@use '@/assets/scss/mo/import-hcon.scss' as *;
@use "@/assets/scss/mo/mo-hcon.scss" as *;
</style>